'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n      width: ', '%;\n    '], ['\n      width: ', '%;\n    ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
var _reactEmotion = require('react-emotion');
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _fontawesomeFreeSolid = require('@fortawesome/fontawesome-free-solid');
var _all = require('../../vendor/gsap/all');
var _ThrowPropsPlugin = require('../../vendor/gsap/ThrowPropsPlugin');
var _ThrowPropsPlugin2 = _interopRequireDefault(_ThrowPropsPlugin);
var _CarouselDots = require('./CarouselDots');
var _CarouselDots2 = _interopRequireDefault(_CarouselDots);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // eslint-disable-line

var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);
  function Carousel(props) {
    _classCallCheck(this, Carousel);
    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this));
    _this.state = {
      activeSlideIndex: props.initialSlide,
      centerIsDisabled: false,
      draggableTrack: null,
      dragIsDisabled: false
    };
    _this.slides = [];
    _this.handleSlideClick = _this.handleSlideClick.bind(_this);
    _this.handleDotClick = _this.handleDotClick.bind(_this);
    _this.handleResponsiveDrag = _this.handleResponsiveDrag.bind(_this);
    _this.handleResponsiveCenter = _this.handleResponsiveCenter.bind(_this);
    return _this;
  }
  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initCenter();
      this.initDrag();
    }
  }, {
    key: 'onThrowComplete',
    value: function onThrowComplete() {
      var snapPoints = this.state.draggableTrack.vars.snap.x;
      var index = snapPoints.indexOf(this.state.draggableTrack.x);
      this.goToSlide(index);
    }
  }, {
    key: 'getCenterElement',
    value: function getCenterElement(index) {
      var el = void 0;
      var slideIndex = typeof index !== 'undefined' ? index : this.state.activeSlideIndex;
      if (this.slides[slideIndex]) {
        el = this.slides[slideIndex];
      } else if (!this.state.dragIsDisabled && window.innerWidth < this.props.responsive.breakpoint) {
        el = this.slides[this.props.initialSlide];
      } else {
        el = this.track;
      }
      return el;
    }
  }, {
    key: 'getCenterOffset',
    value: function getCenterOffset(el) {
      var elRect = el.getBoundingClientRect();
      var windowCenter = window.innerWidth / 2;
      var offset = void 0;
      if (el === this.track) {
        offset = windowCenter - elRect.width / 2;
      } else {
        // Since Rect.x is the position of element relative to its parent container
        // we need to subtract the parent's x postion from the center of slide
        var slideCenterPosition = elRect.width / 2 + elRect.x;
        var trackXPosition = el.parentNode.getBoundingClientRect().x;
        var slideOffset = slideCenterPosition - trackXPosition;
        offset = windowCenter - slideOffset;
      }
      return offset;
    }
  }, {
    key: 'centerElement',
    value: function centerElement(el) {
      var _this2 = this;
      _all.TweenMax.to(this.track, 0.4, {
        x: this.getCenterOffset(el),
        ease: _all.Power1.easeOut,
        onComplete: function onComplete() {
          if (!_this2.state.dragIsDisabled) _this2.state.draggableTrack.update(); // gsap method
        }
      });
    }
  }, {
    key: 'handleDotClick',
    value: function handleDotClick(index) {
      this.goToSlide(index);
    }
  }, {
    key: 'handleResponsiveCenter',
    value: function handleResponsiveCenter() {
      if (this.props.responsive.disableCenter) {
        if (window.innerWidth < this.props.responsive.breakpoint) {
          this.state.centerIsDisabled = false;
          this.centerElement(this.getCenterElement());
        } else if (!this.state.centerIsDisabled) {
          this.disableCenter(this.track);
        }
      } else {
        this.centerElement(this.getCenterElement());
      }
    }
  }, {
    key: 'handleSlideClick',
    value: function handleSlideClick(index) {
      this.props.onSlideClick();
      this.goToSlide(index);
    }
  }, {
    key: 'goToSlide',
    value: function goToSlide(index) {
      var slideCount = this.slides.length;
      var cIndex = void 0;
      if (this.props.infinite) {
        var remainder = index % slideCount;
        cIndex = remainder < 0 ? remainder + slideCount : remainder;
      } else {
        cIndex = index;
      }
      this.updateActiveSlide(cIndex);
      if (!this.state.centerIsDisabled) {
        this.centerElement(this.getCenterElement(cIndex));
      }
    }
  }, {
    key: 'initCenter',
    value: function initCenter() {
      this.handleResponsiveCenter();
      window.addEventListener('resize', (0, _lodash.debounce)(this.handleResponsiveCenter, 300));
    }
  }, {
    key: 'initDrag',
    value: function initDrag() {
      if (this.props.responsive.disableDrag) {
        this.handleResponsiveDrag();
        window.addEventListener('resize', (0, _lodash.debounce)(this.handleResponsiveDrag, 300));
      } else {
        this.createDrag();
        this.updateSnapPoints();
      }
    }
  }, {
    key: 'disableCenter',
    value: function disableCenter(el) {
      _all.TweenMax.set(el, {
        x: 0
      });
      this.setState({
        centerIsDisabled: true
      });
    }
  }, {
    key: 'handleResponsiveDrag',
    value: function handleResponsiveDrag() {
      if (window.innerWidth < this.props.responsive.breakpoint) {
        if (!this.state.draggableTrack) {
          this.createDrag();
          this.initDots();
        } else if (this.state.draggableTrack && this.state.dragIsDisabled) {
          this.enableDrag();
        }
        this.updateSnapPoints();
      } else if (this.state.draggableTrack && !this.state.dragIsDisabled) {
        this.disableDrag();
      }
    }
  }, {
    key: 'createDrag',
    value: function createDrag() {
      var _this3 = this;
      var _Draggable$create = _all.Draggable.create(this.track, {
          dragClickables: true,
          edgeResistance: 0.5,
          minDuration: 0.3,
          maxDuration: 0.4,
          throwProps: true,
          throwResistance: 999999,
          type: 'x',
          snap: {
            x: []
          },
          onThrowComplete: function onThrowComplete() {
            return _this3.onThrowComplete();
          }
        }),
        _Draggable$create2 = _slicedToArray(_Draggable$create, 1),
        draggableTrack = _Draggable$create2[0];
      this.state.draggableTrack = draggableTrack;
    }
  }, {
    key: 'enableDrag',
    value: function enableDrag() {
      this.state.draggableTrack.enable(); // gsap method
      this.state.dragIsDisabled = false;
    }
  }, {
    key: 'disableDrag',
    value: function disableDrag() {
      this.state.draggableTrack.kill(); // gsap method
      this.state.dragIsDisabled = true;
    }
  }, {
    key: 'updateSnapPoints',
    value: function updateSnapPoints() {
      var slide = this.slides[0];
      var slideWidth = Math.round(slide.getBoundingClientRect().width);
      var slideStyle = slide.currentStyle || window.getComputedStyle(slide);
      var slideMargin = slideStyle.marginLeft;
      var regDigits = new RegExp(/\d+/g);
      var marginArr = slideMargin.match(regDigits);

      // slide width plus left and right margins
      var fullSlideWidth = Number(marginArr[0] * 2) + slideWidth;
      var offset = (window.innerWidth - fullSlideWidth) / 2;
      var snapPointsArr = [];

      // Increment the offset by the fullSlideWidth and push new point to array
      this.track.childNodes.forEach(function (el, index) {
        var point = offset - index * fullSlideWidth;
        snapPointsArr.push(point);
      });
      // update gsap draggableTrack snap.x array
      this.state.draggableTrack.vars.snap.x = snapPointsArr;
    }
  }, {
    key: 'updateActiveSlide',
    value: function updateActiveSlide(index) {
      this.setState({
        activeSlideIndex: index
      });
      this.props.onSlideUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;
      var carouselSlideClass = (0, _reactEmotion.css)(_templateObject, 100 / this.props.visible);
      var dots = _react2.default.createElement(_CarouselDots2.default, {
        className: 'carousel__nav',
        ariaControls: this.props.id,
        activeIndex: this.state.activeSlideIndex,
        id: this.props.ariaLabelledby,
        items: this.props.children,
        onClick: this.handleDotClick,
        onKeyPress: this.handleDotClick
      });
      var prevArrow = !this.props.infinite && this.state.activeSlideIndex !== 0 ? _react2.default.createElement('button', {
        className: 'carousel__arrow carousel__arrow--prev',
        onClick: function onClick() {
          return _this4.goToSlide(_this4.state.activeSlideIndex - 1);
        },
        type: 'button',
        'aria-label': 'Previous slide'
      }, _react2.default.createElement(_reactFontawesome2.default, {
        icon: _fontawesomeFreeSolid.faChevronLeft
      })) : null;
      var nextArrow = !this.props.infinite && this.state.activeSlideIndex !== this.slides.length - 1 ? _react2.default.createElement('button', {
        className: 'carousel__arrow carousel__arrow--next',
        onClick: function onClick() {
          return _this4.goToSlide(_this4.state.activeSlideIndex + 1);
        },
        type: 'button',
        'aria-label': 'Next slide'
      }, _react2.default.createElement(_reactFontawesome2.default, {
        icon: _fontawesomeFreeSolid.faChevronRight
      })) : null;
      return _react2.default.createElement('div', {
        className: 'carousel ' + this.props.className
      }, _react2.default.createElement('div', {
        className: 'carousel__track',
        ref: function ref(track) {
          _this4.track = track;
        }
      }, this.props.children.map(function (child, index) {
        return _react2.default.createElement('div', {
          className: 'carousel__slide ' + carouselSlideClass,
          id: _this4.props.id + '-' + index,
          key: 'carousel-slide-' + _shortid2.default.generate(),
          ref: function ref(slide) {
            _this4.slides[index] = slide;
          },
          onClick: function onClick() {
            return _this4.handleSlideClick(index);
          },
          onKeyPress: function onKeyPress() {
            return _this4.handleSlideClick(index);
          },
          role: 'tabpanel',
          'aria-labelledby': _this4.props.ariaLabelledby + '-' + index,
          'aria-hidden': _this4.state.activeSlideIndex !== index
        }, child);
      })), this.props.arrows ? prevArrow : null, this.props.arrows ? nextArrow : null, this.props.dots ? dots : null);
    }
  }]);
  return Carousel;
}(_react2.default.Component);
Carousel.defaultProps = {
  ariaLabelledby: 'tab',
  arrows: false,
  children: null,
  className: '',
  dots: false,
  id: 'tabpanel',
  infinite: false,
  initialSlide: 0,
  visible: 1,
  onSlideUpdate: function onSlideUpdate() {
    return null;
  },
  onSlideClick: function onSlideClick() {
    return null;
  },
  responsive: {
    breakpoint: 0,
    disableCenter: false,
    disableDrag: false
  }
};
Carousel.propTypes = {
  ariaLabelledby: _propTypes2.default.string,
  arrows: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  dots: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  initialSlide: _propTypes2.default.number,
  infinite: _propTypes2.default.bool,
  visible: _propTypes2.default.number,
  onSlideUpdate: _propTypes2.default.func,
  onSlideClick: _propTypes2.default.func,
  responsive: _propTypes2.default.shape({
    breakpoint: _propTypes2.default.number,
    disableCenter: _propTypes2.default.bool,
    disableDrag: _propTypes2.default.bool
  })
};
exports.default = Carousel;